// extracted by mini-css-extract-plugin
export var closeButton = "_oo-2";
export var closeButtonIcon = "_oo-3";
export var lightboxContent = "_oo-1";
export var lightboxOverlay = "_oo-0";